import React, { useState } from "react";
import { Box, Tooltip } from "@mui/material";

interface StarRatingProps {
  scale?: number;
  value: number;
  onChange?: (v: number) => void;
  readOnly?: boolean;
  size?: number;
}

const StarRating: React.FC<StarRatingProps> = ({
  scale = 5,
  value,
  onChange,
  readOnly = false,
  size = 28,
}) => {
  const [hovered, setHovered] = useState<number>(0);

  return (
    <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
      {Array.from({ length: scale }, (_, i) => i + 1).map((star) => (
        <Tooltip key={star} title={readOnly ? "" : `${star} / ${scale}`} disableHoverListener={readOnly}>
          <Box
            component="span"
            onMouseEnter={() => !readOnly && setHovered(star)}
            onMouseLeave={() => !readOnly && setHovered(0)}
            onClick={() => !readOnly && onChange && onChange(star)}
            sx={{
              cursor: readOnly ? "default" : "pointer",
              fontSize: size,
              lineHeight: 1,
              color: star <= (hovered || value) ? "#f5a623" : "#ccc",
              transition: "color 0.15s",
              userSelect: "none",
            }}
          >
            ★
          </Box>
        </Tooltip>
      ))}
    </Box>
  );
};

export default StarRating;
